import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import infoPic from 'src/assets/Buy_Policy_Images/infoIcon.svg'
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import { nomineeRelationType } from 'src/utils/constants/BuyPolicyMotor'
import {
  generatePastYearsArray,
  monthList,
} from 'src/utils/commonMethods/buyPolicy'
import { addScroll, getAge, removeScroll } from 'src/utils/commonMethods'
import {
  COMPANY,
  ERROR_ON_LOAN_PROVIDER,
  GENDER_TYPE_ENUMS,
  YES,
} from 'src/utils/constants/BuyPolicy'
import { getLoanProviderList } from 'src/services/buyPolicyMotorService'
import { getTokenForQrReport } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import { INDIAN_STATES, NOTIFICATION_TYPES } from 'src/utils/constants/common'
import Tooltip from '@mui/material/Tooltip'
import { useDispatch, useSelector } from 'react-redux'
import { VEHICLE_TYPE } from 'src/utils/constants/BuyPolicyBike'
import { showNotificationMessage } from 'src/actions'
import { useHistory } from 'react-router-dom'
import { ScrollToFieldError } from 'src/components/BuyPolicy/insuranceScreens/motor/ScrollToFieldError'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const MotorDetailsForm = ({
  formMotorDetails,
  fetchFullAddress,
  handlePrefillData,
}) => {
  const history = useHistory()
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loanProviderList, setLoanProviderList] = useState([])
  const [loading, setLoading] = useState(false)
  const [loanProviderName, setLoanProviderName] = useState(false)
  const yearList = generatePastYearsArray(80)
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const vehicleType = motorDetails?.vehicleDetails?.vehicleType
  const providerId = motorDetails?.selectedQuote?.providerId

  const handleLoanProviderChange = (event, value) => {
    formMotorDetails.setFieldValue('currentCarLoanProvider', value, true)
  }
  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)

      const token = response?.res?.data?.access_token
      fetchLoanProviderList(token)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchLoanProviderList = async (token) => {
    setLoading(true)

    const response = await getLoanProviderList(token, providerId)
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const responseData = response?.res?.data
      if (responseData) {
        setLoanProviderList(responseData)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: responseData?.message,
          })
        )
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message: ERROR_ON_LOAN_PROVIDER,
        })
      )
    }
  }

  const calculateMinDate = () => {
    const today = new Date()
    return `${today.getFullYear() - 120}-${(today.getMonth() + 1)
      ?.toString()
      ?.padStart(2, '0')}-${today?.getDate()?.toString()?.padStart(2, '0')}`
  }

  const calculateMaxDate = () => {
    const today = new Date()
    return `${today.getFullYear()}-${(today.getMonth() + 1)
      ?.toString()
      ?.padStart(2, '0')}-${today.getDate()?.toString()?.padStart(2, '0')}`
  }

  const handleProceed = async () => {
    formMotorDetails.submitForm()
  }

  const handleBack = () => {
    history.goBack()
  }
  useEffect(() => {
    handlePrefillData()
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Box>
      <LoadingModal loading={loading} />

      <form onSubmit={formMotorDetails.handleSubmit}>
        <ScrollToFieldError formDetails={formMotorDetails} />
        <Box className={classes.backgroundContainer}>
          <Box className={classes.container}>
            <Box className={classes.carDetailsHeading}>Vehicle Details</Box>
            <Box className={classes.carDetailsContainerRow}>
              <Box>
                <FormControl>
                  <p
                    id='carOwnerButtonText'
                    className={classes.carDetailConatinerHeading}
                    fontWeight='500'
                  >
                    Month and Year Of Manufacturing
                  </p>
                  <Box display='flex' gap='10px'>
                    <Select
                      id='manufacturingMonth'
                      name='manufacturingMonth'
                      placeholder={'Select Month *'}
                      displayEmpty
                      defaultValue=''
                      className={classes.inputTextField}
                      onChange={(e) => {
                        formMotorDetails.setFieldValue(
                          'manufacturingMonth',
                          e?.target?.value,
                          true
                        )
                      }}
                      value={formMotorDetails?.values?.manufacturingMonth}
                    >
                      <MenuItem value={''} className={'default-menu-item'}>
                        Select Month
                      </MenuItem>
                      {monthList?.map((month) => (
                        <MenuItem key={month?.value} value={month?.value}>
                          {month?.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <Select
                      id='manufacturingYear'
                      name='manufacturingYear'
                      placeholder={'Select Year *'}
                      displayEmpty
                      defaultValue=''
                      className={classes.inputTextField}
                      onChange={(e) => {
                        formMotorDetails.setFieldValue(
                          'manufacturingYear',
                          e?.target?.value,
                          true
                        )
                      }}
                      value={formMotorDetails?.values?.manufacturingYear}
                    >
                      <MenuItem value={''} className={'default-menu-item'}>
                        Select Year *
                      </MenuItem>
                      {yearList?.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails?.touched?.manufacturingYear &&
                      formMotorDetails?.errors?.manufacturingYear}
                  </FormHelperText>
                </FormControl>
              </Box>
            </Box>
            <Box className={classes.carDetailsContainerRow}>
              <Box>
                <FormControl>
                  <p
                    id='carOwnerButtonText'
                    className={classes.carDetailConatinerHeading}
                    fontWeight='500'
                  >
                    Vehicle is owned by
                  </p>

                  <RadioGroup
                    row
                    aria-labelledby='carOwnerButtonLabel'
                    name='carOwnerButton'
                    value={formMotorDetails?.values?.carOwnedBy}
                    onChange={(e) => {
                      formMotorDetails.setFieldValue(
                        'carOwnedBy',
                        e?.target?.value,
                        true
                      )
                    }}
                    error={
                      formMotorDetails?.touched?.carOwnedBy &&
                      Boolean(formMotorDetails?.errors?.carOwnedBy)
                    }
                  >
                    <FormControlLabel
                      className={classes.formRadioText}
                      value='company'
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={
                        <Box className={classes.RadioBtnText}>Company</Box>
                      }
                    />
                    <FormControlLabel
                      className={classes.formRadioText}
                      value='individual'
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={
                        <Box className={classes.RadioBtnText}>Individual</Box>
                      }
                    />
                  </RadioGroup>
                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails.touched.carOwnedBy &&
                      formMotorDetails.errors.carOwnedBy}
                  </FormHelperText>
                </FormControl>
              </Box>
              {formMotorDetails?.values?.carOwnedBy === COMPANY ? (
                <Box className={classes.ownByCompanyMainContainer}>
                  <Box>
                    <TextField
                      id='CompanyName'
                      name='companyName'
                      size='small'
                      placeholder='Company Name *'
                      onBlur={formMotorDetails.handleBlur}
                      onChange={formMotorDetails.handleChange}
                      value={formMotorDetails?.values?.companyName}
                      helperText={
                        formMotorDetails?.touched?.companyName &&
                        formMotorDetails?.errors?.companyName
                      }
                      error={
                        formMotorDetails?.touched?.companyName &&
                        Boolean(formMotorDetails?.errors?.companyName)
                      }
                    />
                  </Box>
                  <Box>
                    <TextField
                      id='CompanyPan'
                      name='companyPan'
                      size='small'
                      placeholder='Company PAN *'
                      onBlur={formMotorDetails.handleBlur}
                      onChange={formMotorDetails.handleChange}
                      value={formMotorDetails?.values?.companyPan}
                      helperText={
                        formMotorDetails?.touched?.companyPan &&
                        formMotorDetails?.errors?.companyPan
                      }
                      error={
                        formMotorDetails?.touched?.companyPan &&
                        Boolean(formMotorDetails?.errors?.companyPan)
                      }
                    />
                  </Box>
                  <Box>
                    <TextField
                      id='CompanyGstin'
                      name='companyGstin'
                      size='small'
                      placeholder='Company GSTIN'
                      onBlur={formMotorDetails.handleBlur}
                      onChange={formMotorDetails.handleChange}
                      value={formMotorDetails?.values?.companyGstin}
                      helperText={
                        formMotorDetails?.touched?.companyGstin &&
                        formMotorDetails?.errors?.companyGstin
                      }
                      error={
                        formMotorDetails?.touched?.companyGstin &&
                        Boolean(formMotorDetails?.errors?.companyGstin)
                      }
                    />
                  </Box>
                  <Box>
                    <CustomDatePicker
                      id='companyIncorporationDate'
                      name='companyIncorporationDate'
                      placeholder='Incorporation Date *'
                      required
                      onBlur={formMotorDetails.handleBlur}
                      onChange={formMotorDetails.handleChange}
                      value={formMotorDetails?.values?.companyIncorporationDate}
                      helperText={
                        formMotorDetails?.touched?.companyIncorporationDate &&
                        formMotorDetails?.errors?.companyIncorporationDate
                      }
                      error={
                        formMotorDetails?.touched?.companyIncorporationDate &&
                        Boolean(
                          formMotorDetails?.errors?.companyIncorporationDate
                        )
                      }
                      className={`${classes.inputField} ${classes.customDatePick}`}
                    ></CustomDatePicker>
                  </Box>
                </Box>
              ) : null}
            </Box>
            {vehicleType !== VEHICLE_TYPE?.TWO_WHEELER ? (
              <Box className={classes.carDetailsContainerRow}>
                <Box>
                  <FormControl>
                    <p
                      id='externalCNGKitButtonText'
                      className={classes.carDetailConatinerHeading}
                    >
                      Does this car have an external CNG/LPG kit?
                    </p>
                    <Box className={classes.cngSection}>
                      <RadioGroup
                        row
                        name='externalCNGKitButton'
                        value={formMotorDetails?.values?.externalCngLpgKit}
                        onChange={(e) => {
                          formMotorDetails.setFieldValue(
                            'externalCngLpgKit',
                            e?.target?.value,
                            true
                          )
                        }}
                        error={
                          formMotorDetails?.touched?.externalCngLpgKit &&
                          Boolean(formMotorDetails?.errors?.externalCngLpgKit)
                        }
                      >
                        <FormControlLabel
                          className={classes.formRadioText}
                          value='yes'
                          control={
                            <Radio
                              className={classes.radioBtnSelected}
                              size='small'
                            />
                          }
                          label={
                            <Box className={classes.RadioBtnText}>Yes</Box>
                          }
                        />
                        <FormControlLabel
                          className={classes.formRadioText}
                          value='no'
                          control={
                            <Radio
                              className={classes.radioBtnSelected}
                              size='small'
                            />
                          }
                          label={<Box className={classes.RadioBtnText}>No</Box>}
                        />
                      </RadioGroup>
                      {formMotorDetails?.values?.externalCngLpgKit === YES ? (
                        <>
                          <Box className={classes.cngText}>
                            <TextField
                              id='ExternalCngLpgKitAmount'
                              name='externalCngLpgKitAmount'
                              size='small'
                              placeholder='Enter CNG Kit amount *'
                              onBlur={formMotorDetails.handleBlur}
                              onChange={formMotorDetails.handleChange}
                              value={
                                formMotorDetails?.values
                                  ?.externalCngLpgKitAmount
                              }
                              helperText={
                                formMotorDetails?.touched
                                  ?.externalCngLpgKitAmount &&
                                formMotorDetails?.errors
                                  ?.externalCngLpgKitAmount
                              }
                              error={
                                formMotorDetails?.touched
                                  ?.externalCngLpgKitAmount &&
                                Boolean(
                                  formMotorDetails?.errors
                                    ?.externalCngLpgKitAmount
                                )
                              }
                              className={classes.fieldCng}
                              InputProps={{
                                className: classes.inputField,
                              }}
                            />
                            <Box className={classes.purchaseAmountText}>
                              Your purchase value should be between ₹ 10,000 - ₹
                              50,000
                            </Box>
                          </Box>
                        </>
                      ) : null}
                    </Box>

                    <FormHelperText className={classes.errorStyle}>
                      {formMotorDetails?.touched?.externalCngLpgKit &&
                        formMotorDetails?.errors?.externalCngLpgKit}
                    </FormHelperText>
                  </FormControl>
                </Box>
              </Box>
            ) : null}
            <Box className={classes.carDetailsContainerRow}>
              <Box>
                <FormControl>
                  <p
                    id='loanLabel'
                    className={classes.carDetailConatinerHeading}
                  >
                    Is your vehicle currently on loan (Hypothecated To) ?
                  </p>
                  <Box className={classes.cngSection}>
                    <RadioGroup
                      row
                      name='loanPolicyRadioButton'
                      value={formMotorDetails?.values?.isCurrentCarLoan}
                      onChange={(e) => {
                        formMotorDetails.setFieldValue(
                          'isCurrentCarLoan',
                          e?.target?.value,
                          true
                        )
                      }}
                    >
                      <FormControlLabel
                        className={classes.formRadioText}
                        value='yes'
                        control={
                          <Radio
                            className={classes.radioBtnSelected}
                            size='small'
                          />
                        }
                        label={<Box className={classes.RadioBtnText}>Yes</Box>}
                      />
                      <FormControlLabel
                        className={classes.formRadioText}
                        value='no'
                        control={
                          <Radio
                            className={classes.radioBtnSelected}
                            size='small'
                          />
                        }
                        label={<Box className={classes.RadioBtnText}>No</Box>}
                      />
                    </RadioGroup>
                    {formMotorDetails?.values?.isCurrentCarLoan === YES ? (
                      <>
                        <Box>
                          <FormControl
                            size='small'
                            className={classes.fieldCurrentCarLoanProvider}
                          >
                            <Autocomplete
                              id='currentCarLoanProvider'
                              name='currentCarLoanProvider'
                              disableClearable
                              options={loanProviderList ? loanProviderList : []}
                              getOptionLabel={(option) =>
                                option?.loanProviderName || ''
                              }
                              value={
                                formMotorDetails?.values?.currentCarLoanProvider
                              }
                              inputValue={loanProviderName}
                              onInputChange={(event, newInputValue) => {
                                setLoanProviderName(newInputValue)
                              }}
                              onChange={(event, newInsuranceName) => {
                                handleLoanProviderChange(
                                  event,
                                  newInsuranceName
                                )
                              }}
                              className={`${classes.selectWidth} ${classes.currentCarLoan}`}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder={'Loan Provider&apos;s Name *'}
                                  variant='outlined'
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                    className: classes.autoStyle,
                                  }}
                                />
                              )}
                              onOpen={() => {
                                removeScroll()
                              }}
                              onClose={() => {
                                addScroll()
                              }}
                            />
                            <FormHelperText className={classes.errorStyle}>
                              {formMotorDetails?.touched
                                ?.currentCarLoanProvider &&
                                formMotorDetails?.errors
                                  ?.currentCarLoanProvider}
                            </FormHelperText>
                          </FormControl>
                        </Box>
                        <FormControl>
                          <Box className={classes.cngSection}>
                            <TextField
                              id='branchName'
                              name='branchName'
                              size='small'
                              placeholder='Branch Name *'
                              onBlur={formMotorDetails.handleBlur}
                              onChange={formMotorDetails.handleChange}
                              value={formMotorDetails?.values?.branchName}
                              helperText={
                                formMotorDetails?.touched?.branchName &&
                                formMotorDetails?.errors?.branchName
                              }
                              error={
                                formMotorDetails?.touched?.branchName &&
                                Boolean(formMotorDetails?.errors?.branchName)
                              }
                              InputProps={{
                                className: classes.inputField,
                              }}
                            />
                          </Box>

                          <FormHelperText className={classes.errorStyle}>
                            {formMotorDetails?.touched?.isCurrentCarLoan &&
                              formMotorDetails?.errors?.isCurrentCarLoan}
                          </FormHelperText>
                        </FormControl>
                      </>
                    ) : null}
                  </Box>

                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails?.touched?.isCurrentCarLoan &&
                      formMotorDetails?.errors?.isCurrentCarLoan}
                  </FormHelperText>
                </FormControl>
              </Box>
            </Box>
            <Box className={classes.carDetailsContainerRow}>
              <Box>
                <FormControl>
                  <p
                    id='loanLabel'
                    className={classes.carDetailConatinerHeading}
                  >
                    Engine Number :
                  </p>
                  <Box className={classes.cngSection}>
                    <TextField
                      id='engineNumber'
                      name='engineNumber'
                      size='small'
                      placeholder='Engine Number *'
                      onBlur={formMotorDetails.handleBlur}
                      onChange={formMotorDetails.handleChange}
                      value={formMotorDetails?.values?.engineNumber}
                      helperText={
                        formMotorDetails?.touched?.engineNumber &&
                        formMotorDetails?.errors?.engineNumber
                      }
                      error={
                        formMotorDetails?.touched?.engineNumber &&
                        Boolean(formMotorDetails?.errors?.engineNumber)
                      }
                      InputProps={{
                        className: classes.inputField,
                      }}
                    />
                  </Box>

                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails?.touched?.isCurrentCarLoan &&
                      formMotorDetails?.errors?.isCurrentCarLoan}
                  </FormHelperText>
                </FormControl>
              </Box>
            </Box>
            <Box className={classes.carDetailsContainerRow}>
              <Box>
                <FormControl>
                  <p
                    id='loanLabel'
                    className={classes.carDetailConatinerHeading}
                  >
                    Chassis Number :
                  </p>
                  <Box className={classes.cngSection}>
                    <TextField
                      id='chassisNumber'
                      name='chassisNumber'
                      size='small'
                      placeholder='Chassis Number *'
                      onBlur={formMotorDetails.handleBlur}
                      onChange={formMotorDetails.handleChange}
                      value={formMotorDetails?.values?.chassisNumber}
                      helperText={
                        formMotorDetails?.touched?.chassisNumber &&
                        formMotorDetails?.errors?.chassisNumber
                      }
                      error={
                        formMotorDetails?.touched?.chassisNumber &&
                        Boolean(formMotorDetails?.errors?.chassisNumber)
                      }
                      InputProps={{
                        className: classes.inputField,
                      }}
                    />
                  </Box>

                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails?.touched?.isCurrentCarLoan &&
                      formMotorDetails?.errors?.isCurrentCarLoan}
                  </FormHelperText>
                </FormControl>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className={classes.backgroundContainer}>
          <Box className={classes.container}>
            <Box className={classes.personalDetailsHeading}>
              Personal Details
            </Box>
            <Box className={classes.personalDetailsContainerRow}>
              <Box>
                <TextField
                  id='firstName'
                  name='firstName'
                  size='small'
                  placeholder='Insured Person Name *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.firstName}
                  helperText={
                    formMotorDetails?.touched?.firstName &&
                    formMotorDetails?.errors?.firstName
                  }
                  error={
                    formMotorDetails?.touched?.firstName &&
                    Boolean(formMotorDetails?.errors?.firstName)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='lastName'
                  name='lastName'
                  size='small'
                  placeholder='Last Name *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.lastName}
                  helperText={
                    formMotorDetails?.touched?.lastName &&
                    formMotorDetails?.errors?.lastName
                  }
                  error={
                    formMotorDetails?.touched?.lastName &&
                    Boolean(formMotorDetails?.errors?.lastName)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='email'
                  name='email'
                  size='small'
                  placeholder='xyz.abc1111@gmail.com *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.email}
                  helperText={
                    formMotorDetails?.touched?.email &&
                    formMotorDetails?.errors?.email
                  }
                  error={
                    formMotorDetails?.touched?.email &&
                    Boolean(formMotorDetails?.errors?.email)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='mobileNumber'
                  name='mobileNumber'
                  size='small'
                  placeholder='+91 9344 3434 43 *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.mobileNumber}
                  helperText={
                    formMotorDetails?.touched?.mobileNumber &&
                    formMotorDetails?.errors?.mobileNumber
                  }
                  error={
                    formMotorDetails?.touched?.mobileNumber &&
                    Boolean(formMotorDetails?.errors?.mobileNumber)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
            </Box>
            <Box className={classes.personalDetailsContainerRow}>
              <Box>
                <CustomDatePicker
                  id='dateOfBirth'
                  name='dateOfBirth'
                  placeholder='Date Of Birth *'
                  value={formMotorDetails?.values?.dateOfBirth}
                  helperText={
                    formMotorDetails?.touched?.dateOfBirth &&
                    formMotorDetails?.errors?.dateOfBirth
                  }
                  error={
                    formMotorDetails?.touched?.dateOfBirth &&
                    Boolean(formMotorDetails?.errors?.dateOfBirth)
                  }
                  onChange={formMotorDetails.handleChange}
                  className={`${classes.inputField} ${classes.dobField}`}
                />
              </Box>
              <Box>
                <FormControl>
                  <RadioGroup
                    row
                    id='gender'
                    name='gender'
                    value={formMotorDetails.values.gender}
                    onChange={(e) => {
                      formMotorDetails.setFieldValue(
                        'gender',
                        e?.target?.value,
                        true
                      )
                    }}
                  >
                    <FormControlLabel
                      value={GENDER_TYPE_ENUMS?.MALE}
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={<Box className={classes.RadioBtnText}>Male</Box>}
                    />
                    <FormControlLabel
                      value={GENDER_TYPE_ENUMS?.FEMALE}
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={<Box className={classes.RadioBtnText}>Female</Box>}
                    />
                    <FormControlLabel
                      value={GENDER_TYPE_ENUMS?.OTHERS}
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={<Box className={classes.RadioBtnText}>Other</Box>}
                    />
                  </RadioGroup>
                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails?.touched?.gender &&
                      formMotorDetails?.errors?.gender}
                  </FormHelperText>
                </FormControl>
              </Box>
            </Box>
            <Box className={classes.personalDetailsContainerRow}>
              <Box>
                <TextField
                  id='fullAddress'
                  name='fullAddress'
                  size='small'
                  placeholder='Full Address *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.fullAddress}
                  helperText={
                    formMotorDetails?.touched?.fullAddress &&
                    formMotorDetails?.errors?.fullAddress
                  }
                  error={
                    formMotorDetails?.touched?.fullAddress &&
                    Boolean(formMotorDetails?.errors?.fullAddress)
                  }
                  InputProps={{
                    className: classes.inputFieldFullAddress,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='pincode'
                  name='pincode'
                  size='small'
                  placeholder='Pincode *'
                  value={formMotorDetails?.values?.pincode}
                  helperText={
                    formMotorDetails?.touched?.pincode &&
                    formMotorDetails?.errors?.pincode
                  }
                  error={
                    formMotorDetails?.touched?.pincode &&
                    Boolean(formMotorDetails?.errors?.pincode)
                  }
                  onBlur={formMotorDetails.handleBlur}
                  onChange={(e) => {
                    formMotorDetails.handleChange(e)
                    if (e?.target?.value?.length === 6) {
                      fetchFullAddress(e?.target?.value)
                    }
                  }}
                  InputProps={{
                    className: classes.inputFieldAddress,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='city'
                  name='city'
                  size='small'
                  placeholder='City'
                  value={formMotorDetails?.values?.city}
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  InputProps={{
                    className: classes.inputFieldAddress,
                  }}
                />
              </Box>
              <Box>
                {/* <TextField
                  id='state'
                  name='state'
                  size='small'
                  placeholder='State'
                  value={formMotorDetails.values.state}
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  InputProps={{
                    className: classes.inputFieldAddress,
                  }}
                /> */}
                <Select
                  id='state'
                  name='state'
                  placeholder={'Select State '}
                  displayEmpty
                  defaultValue=''
                  className={`${classes.inputTextField} ${classes.stateField}`}
                  onChange={(e) => {
                    formMotorDetails.setFieldValue(
                      'state',
                      e?.target?.value,
                      true
                    )
                  }}
                  value={formMotorDetails?.values?.state}
                >
                  <MenuItem value={''} className={'default-menu-item'}>
                    Select State *
                  </MenuItem>
                  {INDIAN_STATES?.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            </Box>
            <Box className={classes.personalDetailsContainerRow}>
              <Box>
                <TextField
                  id='PAN'
                  name='pan'
                  size='small'
                  placeholder='PAN *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.pan?.toUpperCase()}
                  helperText={
                    formMotorDetails?.touched?.pan &&
                    formMotorDetails?.errors?.pan
                  }
                  error={
                    formMotorDetails?.touched?.pan &&
                    Boolean(formMotorDetails?.errors?.pan)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='Aadhar'
                  name='aadhar'
                  size='small'
                  placeholder='Aadhar(optional)'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.aadhar}
                  helperText={
                    formMotorDetails?.touched?.aadhar &&
                    formMotorDetails?.errors?.aadhar
                  }
                  error={
                    formMotorDetails?.touched?.aadhar &&
                    Boolean(formMotorDetails?.errors?.aadhar)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
              <Box className={classes.kycText}>
                *KYC is mandatory as per recent IRDAI guidelines
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className={classes.backgroundContainer}>
          <Box className={classes.container}>
            <Box className={classes.personalDetailsHeading}>
              <span className={classes.pointOfContactSubHeading}>
                Nominee Details{' '}
              </span>
              <span>
                <Tooltip
                  placement='bottom'
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: `${COLORS.WHITE} !important`,
                        color: COLORS.GREY,
                        textAlign: 'center',
                        fontSize: '15px',
                        padding: '20px',
                        boxShadow: ' 10px 10px 30px  rgba(0, 0, 0, 0.7)',
                        borderRadius: '10px',
                      },
                    },
                    arrow: {
                      sx: {
                        color: `${COLORS.WHITE} !important`,
                      },
                    },
                  }}
                  title={
                    <>
                      <div>
                        In the event of the policyholder&apos;s untimely demise
                        during medical treatment, the nominees are entitled to
                        receive the pre-determined sum assured.
                      </div>
                    </>
                  }
                  arrow
                >
                  <img
                    src={infoPic}
                    alt='infoIcon'
                    className={classes.infoIcon}
                  />
                </Tooltip>
              </span>
            </Box>
            <Box className={classes.personalDetailsContainerRow}>
              <Box>
                <TextField
                  id='nomineeFirstName'
                  name='nomineeFirstName'
                  size='small'
                  placeholder='Nominee First Name *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.nomineeFirstName}
                  helperText={
                    formMotorDetails?.touched?.nomineeFirstName &&
                    formMotorDetails?.errors?.nomineeFirstName
                  }
                  error={
                    formMotorDetails?.touched?.nomineeFirstName &&
                    Boolean(formMotorDetails?.errors?.nomineeFirstName)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='nomineeLastName'
                  name='nomineeLastName'
                  size='small'
                  placeholder='Nominee last Name *'
                  onBlur={formMotorDetails.handleBlur}
                  onChange={formMotorDetails.handleChange}
                  value={formMotorDetails?.values?.nomineeLastName}
                  helperText={
                    formMotorDetails?.touched?.nomineeLastName &&
                    formMotorDetails?.errors?.nomineeLastName
                  }
                  error={
                    formMotorDetails?.touched?.nomineeLastName &&
                    Boolean(formMotorDetails?.errors?.nomineeLastName)
                  }
                  InputProps={{
                    className: classes.inputField,
                  }}
                />
              </Box>
              <Box>
                <TextField
                  id='nomineeDOB'
                  name='nomineeDOB'
                  type='text'
                  placeholder='Date Of Birth *'
                  onFocus={(e) => {
                    e.currentTarget.type = 'date'
                  }}
                  helperText={
                    formMotorDetails?.touched?.nomineeDOB &&
                    formMotorDetails?.errors?.nomineeDOB
                  }
                  error={
                    formMotorDetails?.touched?.nomineeDOB &&
                    Boolean(formMotorDetails?.errors?.nomineeDOB)
                  }
                  value={formMotorDetails?.values?.nomineeDOB}
                  onChange={formMotorDetails.handleChange}
                  InputLabelProps={{}}
                  size='small'
                  InputProps={{
                    className: classes.inputField,
                    endAdornment: (
                      <InputAdornment position='end'>
                        <Button className={classes.ageButton}>
                          {' '}
                          <span className={classes.ageText}>
                            Age:{getAge(formMotorDetails?.values?.nomineeDOB)}
                          </span>
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    min: calculateMinDate(),
                    max: calculateMaxDate(),
                  }}
                />
              </Box>
              <Box>
                <FormControl fullWidth>
                  <Select
                    id='relation'
                    name='relation'
                    placeholder={'Relation'}
                    displayEmpty
                    defaultValue=''
                    onChange={(e) => {
                      formMotorDetails.setFieldValue(
                        'nomineeRelation',
                        e?.target?.value,
                        true
                      )
                    }}
                    className={`${classes.inputTextField} ${classes.nomineeField}`}
                    value={formMotorDetails?.values?.nomineeRelation}
                  >
                    <MenuItem value={''} className={'default-menu-item'}>
                      Relation
                    </MenuItem>
                    {nomineeRelationType?.map((relationListItem) => (
                      <MenuItem
                        key={relationListItem?.value}
                        value={relationListItem?.value}
                      >
                        {relationListItem?.relation}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails?.touched?.nomineeRelation &&
                      formMotorDetails?.errors?.nomineeRelation}
                  </FormHelperText>
                </FormControl>
              </Box>
            </Box>
            <Box className={classes.personalDetailsContainerRow}>
              <Box>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby='motorGenderLabel'
                    id='nomineeGender'
                    name='nomineeGender'
                    value={formMotorDetails?.values?.nomineeGender}
                    onChange={(e) => {
                      formMotorDetails.setFieldValue(
                        'nomineeGender',
                        e?.target?.value,
                        true
                      )
                    }}
                  >
                    <FormControlLabel
                      value={GENDER_TYPE_ENUMS?.MALE}
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={<Box className={classes.RadioBtnText}>Male</Box>}
                    />
                    <FormControlLabel
                      value={GENDER_TYPE_ENUMS.FEMALE}
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={<Box className={classes.RadioBtnText}>Female</Box>}
                    />
                    <FormControlLabel
                      value={GENDER_TYPE_ENUMS?.OTHERS}
                      control={
                        <Radio
                          className={classes.radioBtnSelected}
                          size='small'
                        />
                      }
                      label={<Box className={classes.RadioBtnText}>Other</Box>}
                    />
                  </RadioGroup>
                  <FormHelperText className={classes.errorStyle}>
                    {formMotorDetails?.touched?.nomineeGender &&
                      formMotorDetails?.errors?.nomineeGender}
                  </FormHelperText>
                </FormControl>
              </Box>
            </Box>
          </Box>
        </Box>
      </form>
      <div className={classes.buttonItems}>
        <div>
          <Button
            type={'button'}
            onClick={handleBack}
            className={classes.backButton}
            id='backButton'
          >
            Back
          </Button>
        </div>
        <div>
          <Button
            className={classes.payButton}
            onClick={handleProceed}
            id='proceedButton'
          >
            Proceed
          </Button>
        </div>
      </div>
    </Box>
  )
}

export default MotorDetailsForm

const useStyles = makeStyles({
  backgroundContainer: {
    background: 'linear-gradient(to bottom, #4DC3E3 , #FFFFFF )',
    padding: '1px',
    borderRadius: '11px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    padding: '20px',
    borderRadius: '10px',
    marginBottom: '20px',
    boxShadow: '0px 8px 8px 0px #FFFFFF',
    background: COLORS.WHITE,
  },
  carDetailsContainer: {
    border: '1px solid',
    borderImageSource: 'linear-gradient(180deg, #4DC3E3 0%, #FFFFFF 100%)',
    borderImageSlice: 1,
  },
  carDetailsContainerMain: {
    display: 'flex',
    flexDirection: 'column',
    padding: 30,
    gap: 20,
  },
  carDetailsHeading: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0em',
    color: '#29AACD',
    marginBottom: '-6px',
  },
  stateField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  carDetailsContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  customDatePick: {
    '&  .MuiOutlinedInput-input': {
      height: '0.44rem',
    },
  },
  nomineeField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem !important',
    },
  },
  carDetailConatinerHeading: {
    fontFamily: 'Roboto Light 300',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '21.06px',
    letterSpacing: '0em',
    color: '#000000 !important',
  },
  RadioBtnText: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '19.55px',
    letterSpacing: '0em',
    marginLeft: '-7px',
  },
  purchaseAmountText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0em',
    color: '#909090',
  },
  fieldCng: {
    marginTop: '1.8vw',
    maxWidth: 188,
  },
  commonFieldMargin: {
    marginTop: '1.8vw',
    maxWidth: 160,
    height: '30px',

    fontSize: '13px !important',
    background: '#FFFFFF',
  },
  fieldCurrentCarLoanProvider: {
    marginTop: '1.8vw',
    width: 200,
  },
  dobField: {
    '&  .MuiOutlinedInput-input': {
      height: '0.3rem',
    },
  },
  currentCarLoan: {
    '& .MuiIconButton-root': {
      padding: 'unset',
    },
    '& .MuiOutlinedInput-root': {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 'unset',
    },
  },
  radioBtnSelected: {
    '& .MuiSvgIcon-root': {
      // color: '#44BFE0',
    },
  },
  personalDetailsContainer: {
    border: '1px solid',
    borderImageSource: 'linear-gradient(180deg, #4DC3E3 0%, #FFFFFF 100%)',
    borderImageSlice: 1,
  },
  personalDetailsContainerMain: {
    display: 'flex',
    flexDirection: 'column',
    padding: 30,
    gap: 20,
  },
  personalDetailsContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
  },
  personalDetailsHeading: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0em',
    color: '#29AACD',
  },
  kycText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '16.54px',
    letterSpacing: '0em',
    color: '#909090',
  },
  errorStyle: {
    color: 'red !important',
  },
  formRadioText: {
    marginTop: '-15px',
  },
  inputField: {
    '&::placeholder': {
      fontSize: '13px !important',
    },
    fontSize: '13px !important',
    background: '#FFFFFF',
    '& input[type=date]::-webkit-calendar-picker-indicator': {
      opacity: 1,
      cursor: 'pointer',
      paddingRight: '0 !important',
    },
  },
  inputFieldFullAddress: {
    '&::placeholder': {
      fontSize: '13px !important',
    },
    fontSize: '13px !important',
    background: '#FFFFFF',
    width: '320px',
  },
  inputFieldAddress: {
    '&::placeholder': {
      fontSize: '13px !important',
    },
    fontSize: '13px !important',
    background: '#FFFFFF',
    minWidth: '100px',
  },
  cngText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
    marginTop: '-10px',
  },
  cngSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 40,
    marginRight: 'auto',
  },
  loanProviderName: {
    'MuiOutlinedInput-input.MuiSelect-select': {
      height: 'unset',
    },
    '&::placeholder': {
      fontSize: '13px !important',
    },
    fontSize: '13px !important',
    background: '#FFFFFF',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '13px !important',
    fontFamily: 'Roboto !important',
    width: 200,
    '&::placeholder': {
      fontSize: '13px !important',
      color: 'grey !important',
    },
    // padding: 'unset !important',
    '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input':
      {
        padding: '8.5px 10px',
      },
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  calenderIcon: { color: '#29AACD' },
  ageButton: {
    width: '43px',
    height: '25px',
    color: '#EFEFEF',
    margin: '2px',
    border: '1px',
    borderRadius: '5px !important',
  },
  ageText: {
    color: '#666666',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '40px',
  },
  backButton: {
    color: '#28A6C8 !important',
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    cursor: 'pointer !important',
    width: '130px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    background: '#E4EFF2 !important',
    textTransform: 'none !important',
    fontWeight: 'bold !important',
  },
  continueButton: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: 'white !important',
    background: 'linear-gradient(#4EC4E4 100%, #0288AC 100% ) !important',
    cursor: 'pointer !important',
    width: '130px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    marginLeft: '15px !important',
    textTransform: 'none !important',
    fontWeight: 'bold !important',
  },
  selectWidth: {
    minWidth: 200,
    fontSize: '12px !important',
  },
  autoStyle: {
    fontSize: '12px !important',
    height: '2px !important',
    color: 'black',
    padding: 'unset ',
  },
  buttonItems: {
    display: 'flex',
    marginLeft: '10px',
    padding: '20px',
  },
  payButton: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: 'white !important',
    background:
      'linear-gradient(228.98deg, #4EC4E4 9.13%, #0288AC 167.68%) !important',
    cursor: 'pointer !important',
    width: '265px',
    border: '1px !important',
    padding: '10px !important',
    borderRadius: '10px !important',
    marginLeft: '15px !important',
    textTransform: 'none !important',
    fontWeight: '600 !important',
  },
  ownByCompanyMainContainer: {
    display: 'flex',
    gap: '10px',
  },
})
